document.addEventListener("DOMContentLoaded", () => {
  const url = new URL(window.location.href);

  // Nur auf /collections/*-sale
  if (!/\/collections\/[^/]+-sale(\/|$)/.test(url.pathname)) return;

  // Wenn Availability-Filter noch nicht gesetzt ist
  if (!url.searchParams.has("filter.v.availability")) {
    url.searchParams.set("filter.v.availability", "1");
    const searchParams = url.searchParams.toString();

    // URL aktualisieren ohne Reload
    window.history.replaceState({ searchParams }, "", url.toString());

    // Shopify Facet-System triggern um Produkte neu zu laden
    if (typeof FacetFiltersForm !== "undefined") {
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
  }
});